import { Popover, styled, Switch } from '@mui/material';
import { colors } from '@watter/shared-components';

export const NotificationSettingModalUI = styled(Popover)(({ theme }) => ({
    '& .MuiPopover-paper': {
        zIndex: 0,
        width: '438px',
        borderRadius: '16px',
        boxShadow: '0px 0px 16px 0px #7B7B7B40',
        background: theme.palette.mode === 'dark' ? colors.blackColor : colors.white,
    },
    '&.changePassword': {
        '& .MuiDialog-paper': {
            width: '438px',
            height: '214px',
            padding: theme.spacing(1),
            BorderRadius: '10px',
        },
        '& .header': {
            fontWeight: '700',
            fontSize: '14px',
            lineHeight: '18px',
            letterSpacing: ' 0.25px',
        },
    },
    '& .cstBtnWrapper': {
        '& .MuiBox-root': {
            position: 'relative',
            padding: theme.spacing(0.2),
            margin: '10px 10px',

            '& .cstBtn': {
                width: '200px',

                background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
                padding: theme.spacing(2, 0),
                boxShadow:
                    theme.palette.mode === 'dark'
                        ? '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040'
                        : '0px 0px 2px 0px #00000005 inset, 0px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040',
                letterSpacing: '1.25px',
            },
            '& .cstBtn2': {
                width: '200px',
                background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
                padding: theme.spacing(2, 0),
                boxShadow:
                    theme.palette.mode === 'dark'
                        ? '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040'
                        : '0px 0px 2px 0px #00000005 inset, 0px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040',
                letterSpacing: '1.25px',
                border: '1px solid var(--Color-tokens-Strokes-Neutral-Dark, #47474B)',
            },
            '&:active': {
                background:
                    'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
                borderRadius: theme.spacing(4),
            },

            '&:active::after': {
                content: "''",
                background:
                    'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
                position: 'absolute',
                width: '100%',
                height: '100%',
                zIndex: -1,
                inset: 0,
                borderRadius: theme.spacing(4),
            },
        },
    },
}));

export const CustomSwitch = styled(Switch)(({ theme }) => ({
    width: 42,
    height: 22,
    padding: 0,
    display: 'flex',
    '&:active .MuiSwitch-thumb': {
        width: 16,
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(20px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#00C851',
                opacity: 1,
                border: 0,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 0 0 / 20%)',
        width: 18,
        height: 18,
        borderRadius: 9,
        backgroundColor: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#555',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 200,
        }),
    },
}));
